/**
 * We'll load jQuery, bootstrap and slick carousel
 */

try {
    var jQuery = require('jquery')
    require.ensure(["jquery"], function(jquery) {
        window.$ = window.jQuery = jquery;
        require('summernote');
        require('bootstrap');
        require('bootstrap-select');

        $('[data-toggle="popover"]').popover();

        jQuery('.summernote').summernote({
            height: 200,
            fontNames: ['Hind'],
            fontNamesIgnoreCheck: ['Hind'],
            toolbar: [
                // [groupName, [list of button]]
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['font', ['fontname', 'strikethrough', 'superscript', 'subscript']],
                ['fontsize', ['fontsize']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['insert', ['link']],
                ['height', ['height']],
                ['view', ['codeview', 'help']],
            ],
            popover: {

            }
        });

        $('#userRequirementsModal').modal('show')
    });

    $(window).resize(function() {
        $('.calculator-iframe').each(function(i, obj) {
            obj.style.height = (obj.contentWindow.document.body.scrollHeight + 50) + 'px';
        });
    });
    setTimeout(function() { $(window).trigger('resize'); }, 2000);

    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/service-worker.js')
            .then(function(reg) {
                // successfuly registered
            }).catch(function(err) {
            });
    }
} catch (e) {}
